// removed by extract-text-webpack-plugin
module.exports = {"taskTemplateListOverviewHeader":"TaskTemplateListOverviewHeader__taskTemplateListOverviewHeader__1cx-d","backToOverview":"TaskTemplateListOverviewHeader__backToOverview__1ZpKp","icon":"TaskTemplateListOverviewHeader__icon__2AqGJ"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/TaskTemplateListOverview/TaskTemplateListOverviewHeader/TaskTemplateListOverviewHeader.scss
// module id = 1931
// module chunks = 0